module.exports = {
	"classes": [
		"security-page",
		"header-dark"
	],
	"title": "Security",
	"metas": {
		"description": "Policies Regarding Data Security & Confidentiality."
	},
	"opengraph": {},
	"twittercard": {}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/security/metadata.json
// module id = 1138
// module chunks = 0